var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('button',{on:{"click":_vm.onClick}},[_vm._v("Open modal")]),_c('MentorModal',{attrs:{"mentor":_vm.mentor},on:{"close":_vm.onClose}}),_c('MentorInfoUi',{attrs:{"mentor":_vm.mentorSrc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }